const feedbacks = {
  toasts: {
    create: {
      success: 'Feedback successfully created',
      error: 'An error occurred while creating the feedback',
    },
    fetch: {
      error: 'An error occurred while fetching the feedbacks',
    },
    delete: {
      error: 'An error occurred while deleting the feedback',
    },
  },
  deleteModal: {
    header: 'Delete Feedback',
    body: 'You are about to delete a feedback',
    bulkBody: 'You are about to delete {{num}} feedbacks',
    success: 'Feedback was successfully deleted',
  },
  table: {
    headers: {
      date: 'Date',
      source: 'Source',
      id: 'ID',
      externalId: 'External ID',
      flight: 'Flight',
      airline: 'Airline',
      account: 'Account',
      driver: 'Driver',
      vehicle: 'Vehicle',
      feedback: 'Feedback',
      rating: 'Rating',
      by: 'By',
      phone: 'Phone',
      contact: 'Contact',
    },
    filters: {
      flight: 'Flight',
      airline: 'Airline',
      driver: 'Driver',
      vehicle: 'Vehicle',
    },
    source: {
      crewLink: 'CrewLink',
      qr: 'QR',
      tripCard: 'Trip Card',
    },
    actions: {
      delete: 'Delete',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
};

export default feedbacks;
